import { ModalityKey } from "./pricing";
import { ProductType } from "./calculator";

export type Step = 1 | 2 | 3;

export interface AppState {
  step: Step;
  productType: ProductType | null;
  modality: ModalityKey | null;
  productCount: number;
  photosPerProduct: number;
  name: string;
  whatsapp: string;
  errors: Record<string, string | undefined>;
}

const STORAGE_KEY = "producto-estimador-state-v1";

export function createInitialState(defaults: { productCount: number; photosPerProduct: number }): AppState {
  return {
    step: 1,
    productType: null,
    modality: null,
    productCount: defaults.productCount,
    photosPerProduct: defaults.photosPerProduct,
    name: "",
    whatsapp: "",
    errors: {}
  };
}

/**
 * "Corregir datos" must preserve everything already entered. We keep state
 * in memory (module-level) for the lifetime of the page — no localStorage,
 * no cookies, per the privacy constraints of this app.
 */
export function goToStep(state: AppState, step: Step): AppState {
  return { ...state, step, errors: {} };
}
